import { useQuery } from 'react-query';

import { PoolMaintenance } from '../types';

import { getPoolMaintenanceTableDataConverter } from '../utils/getPoolMaintenanceTableDataConverter';

import { getPools } from 'RestAPIs/poolMaintenance';

export const useGetPoolMaintenanceTableData = (
  options?: Record<string, unknown>
) =>
  useQuery<PoolMaintenance[]>(
    ['poolMaintenance', 'list'],
    async () => await getPools().then(getPoolMaintenanceTableDataConverter),
    options
  );
